import { render, staticRenderFns } from "./processdetails.vue?vue&type=template&id=71e71f61"
import script from "./processdetails.vue?vue&type=script&lang=js"
export * from "./processdetails.vue?vue&type=script&lang=js"
import style0 from "./processdetails.vue?vue&type=style&index=0&id=71e71f61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports